exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__info___1ve0l .style__value___3-RCf {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden; }\n\n.style__info___1ve0l {\n  display: inline-block; }\n  .style__info___1ve0l .style__value___3-RCf {\n    color: #000000;\n    opacity: 75%;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 400; }\n  .style__info___1ve0l .style__dot___2-_dz {\n    position: static;\n    width: 4px;\n    height: 4px;\n    background: #c4c4c4;\n    display: inline-block;\n    margin-left: 6px;\n    margin-bottom: 3px;\n    margin-right: 6px;\n    border-radius: 50%; }\n\n.style__summary___1Bp9r {\n  margin-top: 12px;\n  display: flex;\n  justify-content: space-between;\n  height: 48px;\n  overflow: hidden; }\n", ""]);

// exports
exports.locals = {
	"info": "style__info___1ve0l",
	"value": "style__value___3-RCf",
	"dot": "style__dot___2-_dz",
	"summary": "style__summary___1Bp9r"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SimilarAdCard/SummaryBar/style.scss
// module id = 4128
// module chunks = 6